// extracted by mini-css-extract-plugin
module.exports = {"root":"Tutorial_root__2e9sg","body":"Tutorial_body__C2chz","titleContainer":"Tutorial_titleContainer__1ScTL","title":"Tutorial_title__tnYC8"};